<template>
    <div class="map-sidepanel-right" :class="{ open: modelValue }" role="dialog"
        :aria-label="effectiveTitle || 'Panneau carte (droite)'">
        <header class="px-3 py-2 border-bottom d-flex align-items-center justify-content-between">
            <strong v-if="effectiveTitle">{{ effectiveTitle }}</strong>
            <button class="btn btn-sm btn-outline-secondary" @click="$emit('update:modelValue', false)">
                Fermer
            </button>
        </header>
        <div class="p-3 panel-content">
            <!-- Contenu fourni par la carte -->
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'MapSidePanelRight',
    props: {
        /** v-model pour open/close */
        modelValue: { type: Boolean, default: false },
        title: { type: String, default: null },
    },
    emits: ['update:modelValue'],
    inject: {
        injectedTitle: { from: 'rightPanelTitle', default: null },
    },
    computed: {
        effectiveTitle() {
            // Priorité : prop directe > titre injecté > fallback
            return this.title || this.injectedTitle || 'Détails';
        },
    },
};
export { };
</script>

<style scoped>
.map-sidepanel-right {
    position: fixed;
    top: calc(var(--app-header-height, 0px) + 1rem);
    right: 1rem;
    width: clamp(280px, 30vw, 360px);
    max-height: calc(100dvh - var(--app-header-height, 0px) - 2rem);
    background: #fff;
    border-radius: .75rem;
    box-shadow: 0 10px 30px rgba(0, 0, 0, .15);
    transform: translateX(calc(100% + 1rem));
    transition: transform .25s ease;
    z-index: 2000;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.map-sidepanel-right.open {
    transform: translateX(0);
}

.panel-content {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    padding-left: .25rem;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.panel-content::-webkit-scrollbar {
    width: 0;
    height: 0;
}
</style>
